module.exports = "//d274d294w9cx2v.cloudfront.net/a80bdc6fa8ed1812217fa03bcee3055d83ea2eb2/images/photo-couple-wide.png";